import { TabPanel } from '@mui/lab';
import Box from '@mui/material/Box';
import { Input } from '../../../../../shared/components/Input';
import Divider from '@mui/material/Divider';
import { InputCNPJCPF } from '../../../../../shared/components/InputCNPJ';
import { GridColDef } from '@mui/x-data-grid';
import DataTable from '../../../../../shared/components/Table';
import { Button } from '@mui/material';
import { Save, Update } from '@mui/icons-material';

const TIPO_FRETE = [
  {
    id: 0,
    label: '0 = Contratação do Frete por conta do Remetente (CIF)'
  },
  {
    id: 1,
    label: '1 = Contratação do Frete por conta do Destinatário (FOB)'
  },
  {
    id: 2,
    label: '2 = Contratação do Frete por conta de Terceiros'
  },
  {
    id: 3,
    label: '3 = Transporte Próprio por conta do Remetente'
  },
  {
    id: 4,
    label: '4 = Transporte Próprio por conta do Destinatário'
  },
  {
    id: 9,
    label: '9 = Sem Ocorrência de Transporte'
  }
]

const COLUMNS: GridColDef[] = [
  {
    field: 'qVol',
    headerName: 'Quantidade',
    headerAlign: 'center',
    align: 'center',
    width: 200,
  },
  {
    field: 'pesoL',
    headerName: 'Peso Líquido',
    headerAlign: 'center',
    align: 'center',
    width: 200,
  },
  {
    field: 'pesoB',
    headerName: 'Peso Bruto',
    headerAlign: 'center',
    align: 'center',
    width: 200,
  },
  {
    field: 'esp',
    headerName: 'Espécie',
    headerAlign: 'center',
    align: 'center',
    width: 200,
  },
  {
    field: 'marca',
    headerName: 'Marca',
    headerAlign: 'center',
    align: 'center',
    width: 200,
  }
]

interface TabTransporteProps {
  values: any;
  transportador: any;
  createTransportador: () => void;
  updateTransportador: () => void;

}

export const TabTransporte = ({ values, transportador, createTransportador, updateTransportador } : TabTransporteProps) => {

  const handleFreteType = (freteId: number): string => {
    const frete = TIPO_FRETE.find((item) => item.id == freteId);
    if (!frete) return ''
    return frete.label;
  }

  return (
    <TabPanel value='6'>
      <Box className='grid grid-cols-8 gap-7 pt-4'>
        <Input
          disabled={true}
          label='Modalide Frete'
          className='col-span-3'
          name='usu_nome'
          value={handleFreteType(values?.nfeProc?.NFe?.infNFe?.transp?.modFrete)}
        />
        <Box className={'col-span-5'} />
        <Divider className='col-span-8' />
        <Input
          disabled={true}
          label='Transportador'
          className='col-span-4'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.transp?.transporta?.xNome}
        />
        <InputCNPJCPF
          disabled={true}
          label='CNPJ'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.transp?.transporta?.CNPJ}
        />
        <Input
          disabled={true}
          label='Inscrição Estadual'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.transp?.transporta?.IE}
        />
        <Input
          disabled={true}
          label='Endereço'
          className='col-span-3'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.transp?.transporta?.xEnder}
        />
        <Input
          disabled={true}
          label='Município'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.transp?.transporta?.xMun}
        />
        <Input
          disabled={true}
          label='UF'
          className='col-span-1'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.transp?.transporta?.UF}
        />
      </Box>
      <Box className='col-span-8 py-4 pt-8'>
        <DataTable
          hideFooter={true}
          height={'20vh'}
          columns={COLUMNS}
          rows={
            values?.nfeProc?.NFe?.infNFe?.transp?.vol
              ? [{...values?.nfeProc?.NFe?.infNFe?.transp?.vol, id: 1}]
              : []
          }
          showFilter={false}
          showButtonToXlsx={false}
        />
      </Box>
      <Box className='grid grid-cols-8 gap-7 pt-6'>
        <Divider className='col-span-8' />
        <Input
          disabled={true}
          label='Código Transportadora'
          className='col-span-1'
          name='for_id'
          value={transportador?.cli_id ?? ''}
        />
        <Input
          disabled={true}
          label=''
          className='col-span-4'
          name='usu_nome'
          value={transportador?.cli_nome ?? ''}
        />
        <Box className='col-span-1' />
        <Box className='col-span-2 pt-2'>
          {!transportador?.cli_id && (
            <Button
              fullWidth
              startIcon={<Save />}
              variant='contained'
              color='primary'
              size='large'
              className='col-span-6'
              onClick={() => createTransportador()}
            >
              Criar
            </Button>
          )}
          {transportador?.cli_id && (
            <Button
              fullWidth
              startIcon={<Update />}
              variant='contained'
              color='primary'
              size='large'
              className='col-span-6'
              onClick={() => updateTransportador()}
            >
              Atualizar
            </Button>
          )}
        </Box>
      </Box>

    </TabPanel>
  )
}